import React from "react";
import { Route, Switch } from "react-router";
import "./consumer-index.style.scss";
import LandingPage from "./LandingPage/LandingPage";
export default function ConsumerIndex() {
  return (
    <div className="consumer-index">
      <Switch>
        <Route path="/" component={LandingPage} />
      </Switch>
    </div>
  );
}
